<template>
  <div>
    <div :id="id.toString()" class="index-chip pointer mt-1"
         :class="id === vuexSelectedIndexItem ? dynClass : ''">
      <div>
        <div class="text-center index-chip-left">{{description}}</div>
        <div class="text-center index-chip-right">
          {{metric | numberAbb}}
        </div>
        <b-tooltip :target="id.toString()" triggers="hover">
          <h6>{{tooltipMsg}}</h6>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
  // *****************************************************************************************************************
  //                                                  IMPORTS
  // *****************************************************************************************************************
  // import { } from '../../expertoRetail/defaultPayloads/organismStockBreak'
  // import { sales } from '../../services/api/ExpertoRetail'
  // import { DimensionUtils, GeneralUtils } from '@/mixins/index'
  import {reportParameters} from '../../library/requestParameters/generalKeyApiAnalysisRequestParameters'

  export default {
    name: 'IndexFilterChip',
    // *****************************************************************************************************************
    //                                                 MIXINS
    // *****************************************************************************************************************
    mixins: [],
    // *****************************************************************************************************************
    //                                                  PROPS
    // *****************************************************************************************************************
    props: {
      id: {
        required: true,
        default: 0
      },
      description: {
        required: true,
        default: 'some desc'
      },
      metric: {
        required: true,
        default: 0
      },
      metricName: {
        required: true,
        default: 'Metric'
      },
      selectedItem: {
        required: false,
        default: 0
      }
    },
    // *****************************************************************************************************************
    //                                                  COMPONENTS
    // *****************************************************************************************************************
    components: {},
    data () {
      return {
        dynClass: 'bg-primary',
        tooltipMsg: ''
      }
    },
    // *****************************************************************************************************************
    //                                                HOOKS
    // *****************************************************************************************************************
    created () {
      this.setTooltip()
    },
    watch: {},
    computed: {
      vuexSelectedIndexItem () {
        return this.$store.state.dimensionFilterQuickAccess.selectedIndexItem['id']
      },
      vuexSelectedReport () {
        return this.$store.state.generalKeyKpiAnalysis.selectedReport
      }
    },
    // *****************************************************************************************************************
    //                                                METHODS
    // *****************************************************************************************************************
    methods: {
      setTooltip () {
        let tooltipObj = {
          description: this.description,
          metric: this.$_numberNumeralFormat_2(this.metric)
        }
        this.tooltipMsg = reportParameters[this.vuexSelectedReport].chipTooltip(tooltipObj)
      }
      // ********************************************** VUEX COMMITS ***************************************************
      // ********************************************** REQUESTS *******************************************************
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/components/DimensionFilterQuickAccess/IndexFilterChip.vue